export default "__VITE_ASSET__Ve5IBIEW__"